// extracted by mini-css-extract-plugin
export var carrierIcon = "_uz-0";
export var carrierLogo = "_uz-1";
export var detailsSection = "_uz-2";